import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  DashPlaceholder,
  Flex,
  Text,
  Button,
  A,
  Image,
  mainTheme,
} from 'dash-ui';
import { formatAddress } from 'dash-common';

import { GetOrganizationByIdQuery } from 'gql/generated.graphql';
import SaveOrganizationModal from 'pages/organizations/OrganizationDetailsPage/components/SaveOrganizationDetailsModal/SaveOrganizationDetailsModal';

interface IProps {
  organization: GetOrganizationByIdQuery['getOrganizationById'];
}

function OrganizationDetailsHeader({ organization }: IProps) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { t: tOrganizationPage } = useTranslation('pages', {
    keyPrefix: 'organisationPage',
  });
  const { website, location, name, logoFile } = organization;

  return (
    <Box px={6} py={4} w="100%">
      <Flex flexDirection="row" alignItems="center">
        {logoFile ? (
          <Image src={logoFile?.publicUrl} size={92} fit="contain" />
        ) : (
          <DashPlaceholder size={92} />
        )}

        <Flex
          flexDirection="row"
          justifyContent="space-between"
          flex={1}
          w="100%"
          ml={12}
        >
          <Flex flexDirection="column" justifyContent="space-between">
            <Text xl bold>
              {name}
            </Text>
            {location ? (
              <Text color={mainTheme.colors.n80}>
                {formatAddress(location.address)}
              </Text>
            ) : (
              <Text
                color={mainTheme.colors.n80}
              >{tOrganizationPage`addressUnavailable`}</Text>
            )}
            {website ? (
              <A href={website} target="_blank">
                {website}
              </A>
            ) : (
              <Text
                color={mainTheme.colors.n80}
              >{tOrganizationPage`websiteUnavailable`}</Text>
            )}
          </Flex>
        </Flex>

        <Button
          variation="outline"
          round
          icon="edit"
          onClick={() => setIsEditModalOpen(true)}
        />
      </Flex>

      <SaveOrganizationModal
        organization={organization}
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
      />
    </Box>
  );
}

export default OrganizationDetailsHeader;
